import React from 'react';
import Image1 from 'assets/images/onboarding_snap_save_1.png';
import Image2 from 'assets/images/onboarding_snap_save_2.png';
import Image3 from 'assets/images/onboarding_snap_save_3.png';

const SnapSave = ({ animationCount }) => {
  return (
    <div
      className={`position-relative flex-fill d-md-block onboarding-bicycle with-hover ${
        animationCount ? `anim-${animationCount}` : ''
      }`}
    >
      <img src={Image1} alt='man-bycicle' className='man-bicycle' />
      <img src={Image2} alt='bycicle' className='bicycle' />
      <img src={Image3} alt='bycicle' className='shop' />
    </div>
  );
};

export default SnapSave;
